/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Defines the IDs for features in the model objects.  Each feature ID is prefixed by the model class name, followed by the feature name.   They can be used to identify the feature to be changed through the generic set(), add() and remove() methods on each model object.
 */
export default class Features extends BaseMoserObject{

	static IS_UNIQUE = 1;

	static INDEXED_COLUMN = 2;

	static FK_COLUMN = 3;

	static SECURITY_OBJECT = 4;

	static EXPRESSION = 5;

	static REF = 6;

	static ORIGINAL_REF = 7;

	static CLASSIFIER = 8;

	static INSTANCE_TYPE = 9;

	static FILTER = 10;

	static ITEM = 11;

	static ITEM_NORMALIZATION = 12;

	static SHORTCUT_TARGET_QUERY_SUBJECT_REF = 13;

	static SECURITY_FILTER = 14;

	static GENERATE_SQL = 15;

	static USE_IN_JOIN_PATH = 16;

	static NUMBER_OF_ROWS = 17;

	static ROW_COUNT = 18;

	static QUERY_SUBJECT_USAGE = 19;

	static USE_LOCAL_CACHE = 20;

	static SELECT_LIST_CONTROL = 21;

	static SQL_QUERY = 22;

	static QUERY_OPERATION = 23;

	static JOIN_OPERATION = 24;

	static SOURCE_CATEGORY = 25;

	static SORT_LIST = 26;

	static DATA_CACHE_EXPIRY = 27;

	static TREAT_AS = 28;

	static TIME_REF = 29;

	static TIME_GRAIN = 30;

	static TIME_ANCHOR = 31;

	static METRIC_DEFINITION_REF = 32;

	static VISUALIZATION = 33;

	static ACTIVE_TIME_GRAIN = 34;

	static ACTIVE_TIME_REF = 35;

	static COLUMN_DEPENDENCY = 36;

	static QUERY_ITEM = 37;

	static LEFT = 38;

	static RIGHT = 39;

	static LINK = 40;

	static JOIN_FILTER_TYPE = 41;

	static SHORTCUT_TARGET_RELATIONSHIP_REF = 42;

	static DEFAULT_VALUE = 43;

	static FRESHNESS = 44;

	static LOAD_AS_NEEDED = 45;

	static PARAMETER_MAP_ENTRY = 46;

	static QUERY_ITEM_MAP = 47;

	static SEGMENT = 48;

	static USE_EXPRESSION = 49;

	static DISPLAY_EXPRESSION = 50;

	static SORT_EXPRESSION = 51;

	static VERSION = 52;

	static CONTAINER = 53;

	static USE = 54;

	static USE_SPEC = 55;

	static EXPRESSION_LOCALE = 56;

	static FM_MODEL = 57;

	static LAST_MODIFIED = 58;

	static DATA_SOURCE = 59;

	static QUERY_SUBJECT = 60;

	static CALCULATION = 61;

	static RELATIONSHIP = 62;

	static PARAMETER_MAP = 63;

	static METADATA_TREE_VIEW = 64;

	static METADATA_TREE_VIEW_FOCUS = 65;

	static TEXT_RESOURCE = 66;

	static DRILL_GROUP = 67;

	static NAMED_SET = 68;

	static PARAMETER_VALUE_SET = 69;

	static PROMPT = 70;

	static WHAT_IF_MODEL = 71;

	static TRANSLATION = 72;

	static CUSTOM_SORT = 73;

	static DATA_RETRIEVAL_MODE = 74;

	static REF_ACTIVE_PARAMETER_VALUE_SET = 75;

	static LOCATION = 76;

	static ERROR_CODE = 77;

	static MSG = 78;

	static SEVERITY = 79;

	static RULE_ID = 80;

	static DETAIL_MSG = 81;

	static ERROR_DATA = 82;

	static TYPE = 83;

	static DATA = 84;

	static PARENT_GROUP_REF = 85;

	static CARDINALITY = 86;

	static KEY = 87;

	static ATTRIBUTE = 88;

	static RESOURCE_LANGUAGE = 89;

	static CONTEXT = 90;

	static IDENTIFIER = 91;

	static STORE_ID = 92;

	static SEARCH_PATH = 93;

	static IMPORTS = 94;

	static ANCESTORS = 95;

	static PROPERTY = 96;

	static DATA_SOURCE_OVERRIDE = 97;

	static ENABLED = 98;

	static CUSTOM_SORT_REF = 99;

	static SORT_ITEM = 100;

	static FOLDER = 101;

	static ITEM_HIERARCHY = 102;

	static POSITION_AFTER = 103;

	static CM_DATA_SOURCE = 104;

	static CONNECTION_STRING = 105;

	static JDBC = 106;

	static CSV_URL = 107;

	static USER = 108;

	static PASSWORD = 109;

	static DATABASE_TYPE = 110;

	static CATALOG = 111;

	static SCHEMA = 112;

	static TABLE = 113;

	static STORED_PROCEDURE = 114;

	static DB_FUNCTION = 115;

	static CUBE = 116;

	static CUBE_DESCRIPTION = 117;

	static CUBE_PATH = 118;

	static CUBE_CREATED_ON = 119;

	static CUBE_DATA_UPDATED_ON = 120;

	static CUBE_SCHEMA_UPDATED_ON = 121;

	static CUBE_IS_OPTIMIZED = 122;

	static CUBE_DEFAULT_MEASURE = 123;

	static CUBE_CURRENT_PERIOD = 124;

	static NAME = 125;

	static DESCRIPTION = 126;

	static HIDDEN = 127;

	static ORIGINAL_NAME = 128;

	static ID_FOR_EXPRESSION = 129;

	static VALUE = 130;

	static JDBC_URL = 131;

	static DRIVER_CLASS_NAME = 132;

	static CONNECTION_PROPERTIES = 133;

	static TABLE_TYPE = 134;

	static COLUMN = 135;

	static INDEX = 136;

	static PRIMARY_KEY = 137;

	static FOREIGN_KEY = 138;

	static TABLE_ITEM = 139;

	static DATATYPE = 140;

	static NULLABLE = 141;

	static VENDOR_TYPE = 142;

	static VENDOR_FORMAT = 143;

	static COLUMN_NAME = 144;

	static SORT_ORDER = 145;

	static KEYED_COLUMN = 146;

	static PK_CATALOG = 147;

	static PK_SCHEMA = 148;

	static PK_TABLE = 149;

	static PK_COLUMN = 150;

	static STRUCT = 151;

	static MULTISET = 152;

	static PROC_PARAMETER = 153;

	static PARAMETER_NAME = 154;

	static MODE = 155;

	static RESULT_DATATYPE = 156;

	static LABEL = 157;

	static COMMENT = 158;

	static SCREEN_TIP = 159;

	static PROPERTY_OVERRIDE = 160;

	static EDIT_MODE = 161;

	static ORIGINAL_DESCRIPTION = 162;

	static ORIGINAL_LABEL = 163;

	static ORIGINAL_SCREEN_TIP = 164;

	static TRANSIENT_SOURCE = 165;

	static POST_AUTO_AGGREGATION = 166;

	static FILTER_USAGE = 296;

	static ITEM_NORMALIZATION_GROUP = 167;

	static DISPLAY_PATH = 168;

	static CM_SEARCH_PATH = 169;

	static DATASOURCE_REF = 170;

	static SQL_TEXT = 171;

	static SQL_TYPE = 172;

	static PROJECTED_ITEM = 173;

	static QUERY_REF = 174;

	static SET_OPERATION = 175;

	static DUPLICATES = 176;

	static PERIOD_NAME = 177;

	static NUM_PERIODS = 178;

	static PERSPECTIVE = 179;

	static THE_DATE = 180;

	static KEY_REF = 181;

	static CONCEPTS = 182;

	static MINIMUM_VALUE = 183;

	static MAXIMUM_VALUE = 184;

	static NUMBER_OF_DISTINCT_VALUES = 185;

	static NUMBER_OF_NULL_VALUES = 186;

	static ORDERED_VALUES = 187;

	static HIERARCHY_HAS_MULTIPLE_ROOTS = 188;

	static CALCULATED_MEMBER = 189;

	static ROOT_MEMBER = 190;

	static MEMBERS = 191;

	static USAGE = 192;

	static FORMAT = 193;

	static REGULAR_AGGREGATE = 194;

	static DATATYPE_CATEGORY = 195;

	static HIGHLEVEL_DATATYPE = 196;

	static FACET_DEFINITION = 197;

	static TAXONOMY = 198;

	static SPLIT_DEFINITION = 199;

	static AGGREGATE_MODE = 200;

	static ROLE = 201;

	static PROMPT_INFO = 202;

	static METRIC_ROLE = 203;

	static METRIC_SENTIMENT = 204;

	static DOMAIN = 205;

	static CLAZZ = 206;

	static FAMILY = 207;

	static COLUMN_TREATMENT = 208;

	static DISPLAY = 209;

	static FOLDER_LABEL = 210;

	static RELATIONSHIP_REF = 211;

	static PROMPT_TYPE = 212;

	static PROMPT_CASCADE_ON_REF = 213;

	static PROMPT_DISPLAY_ITEM_REF = 214;

	static PROMPT_FILTER_ITEM_REF = 215;

	static PROMPT_USE_ITEM_REF = 216;

	static DIMENSION_UNIQUE_NAME = 217;

	static PARENT_UNIQUE_NAME = 218;

	static LEVEL_NUMBER = 219;

	static LEVEL_LABEL = 220;

	static LEVEL_UNIQUE_NAME = 221;

	static MEMBER_CAPTION = 222;

	static HIERARCHY_UNIQUE_NAME = 223;

	static PARENT_LEVEL = 224;

	static CALCULATED_MEMBER_TYPE = 225;

	static FROM_LOCALE = 226;

	static TO_LOCALE = 227;

	static ACTIVATION = 228;

	static FROM_REF = 229;

	static TO_REF = 230;

	static ID_REF = 231;

	static FROM_REF_CASE_SENSITIVITY = 232;

	static ID_REF_CASE_SENSITIVITY = 233;

	static REF_TO_HIERARCHY = 234;

	static MINCARD = 235;

	static MAXCARD = 236;

	static LEFT_REF = 237;

	static RIGHT_REF = 238;

	static COMPARISON_OPERATOR = 239;

	static VALUE_REF = 240;

	static WHAT_IF_DEFINITION = 241;

	static LOCAL_REF = 242;

	static CASE_SENSITIVE_SEARCH = 243;

	static VALUE_SEARCH = 244;

	static VALUE_LIST = 245;

	static PARAMETER_VALUE = 246;

	static DATA_TYPE = 247;

	static INVERT = 248;

	static VALUES = 249;

	static OPERATOR = 250;

	static USE2 = 251;

	static DISPLAY2 = 252;

	static MODEL_FILTER_ITEM = 253;

	static CAPABILITIES = 254;

	static OPTIONAL = 255;

	static MULTIVALUED = 256;

	static DISCRETE_VALUE = 257;

	static BOUND_RANGE = 258;

	static UNBOUNDED_RANGE = 259;

	static UI_CONTROL_REFERENCE = 260;

	static LOWER_LIMIT = 261;

	static UPPER_LIMIT = 262;

	static STATIC_VALUE_SELECTOR = 263;

	static QUERY_VALUE_SELECTOR = 264;

	static REF_DRILL_GROUP = 265;

	static DIRECTION = 266;

	static NULL_PLACEMENT = 267;

	static FOLDER_ITEM = 268;

	static INTENT = 269;

	static SIGNIFICANT = 270;

	static INFLUENTIAL = 271;

	static LINE = 272;

	static CHARACTER = 273;

	static VALIDATION_MESSAGE = 274;

	static TEXT = 275;

	static COLUMN_NAME_PATTERN = 276;

	static LOOKUP_MODULE = 277;

	static LOOKUP_TABLE_ID = 278;

	static LOOKUP_COLUMN_ID = 279;

	static JOIN_RELATIONSHIP = 280;

	static SPLIT_RULES = 281;

	static EXTERNAL_NAME = 282;

	static DEF_LINK = 283;

	static ITEM_REF = 284;

	static KEY_CONSTRAINT = 285;

	static KEY_COMPOSITION = 286;

	static SQL_OPERATOR = 287;

	static DEFAULT_NAME = 288;

	static ORIGINAL_CM_DATA_SOURCE = 289;

	static ORIGINAL_CATALOG = 290;

	static ORIGINAL_SCHEMA = 291;

	static OVERRIDE_CM_DATA_SOURCE = 292;

	static OVERRIDE_CATALOG = 293;

	static OVERRIDE_SCHEMA = 294;

	static ORDER = 295;


}


// WEBPACK FOOTER //
// ./src/generated/Features.js